import { render, staticRenderFns } from "./WasteLogReport.vue?vue&type=template&id=0ca5631f&"
import script from "./WasteLogReport.vue?vue&type=script&lang=js&"
export * from "./WasteLogReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports